module.exports = __webpack_public_path__ + "img/IQC.f0508871.jpg";